import React from 'react'
import { Switch, Route } from 'react-router-dom'
import BrandAmbassador from './BrandAmbassador';
import { Container } from '@mui/material';

const Main = () => (
    <main>
      <div className="container-fluid">
        <Container maxWidth="sm">
          <Switch>
            <Route path='/:brandAmbassadorCode' component={BrandAmbassador}/>
          </Switch>
        </Container>
      </div>
    </main>
  )
  
  export default Main
  